import { getClerkInstance } from "@clerk/clerk-expo";
import axios from "axios";

const getToken = async () => {
	const token = await getClerkInstance().session?.getToken({
		template: "jwt-with-user",
		skipCache: true,
	});
	return token;
};

const authAxios = axios.create();

authAxios.interceptors.request.use(async (config) => {
	const token = await getToken();

	config.headers.Authorization = token;
	return config;
});

export default authAxios;
